export default __webpack_public_path__ + "static/media/logo finance (2).392d73a1.png";